import Alpine from 'alpinejs';
import { initAppStore } from './stores/appStore';
import { registerFavouritesComponent } from './components/favourites';
import { registerWasmPlayground } from './components/wasmPlayground';
import { registerSiteSearch } from './components/siteSearch';
import { registerMicroFeed } from './components/microFeed';

initAppStore(Alpine);
registerFavouritesComponent(Alpine);
registerWasmPlayground(Alpine);
registerSiteSearch(Alpine);
registerMicroFeed(Alpine);

window.Alpine = Alpine;
Alpine.start();
